var map = {
	"./cricket_summaryLive.json": 800,
	"./cricket_summaryLive2.json": 801
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 799;



//////////////////
// WEBPACK FOOTER
// ../mock-data ^\.\/.*$
// module id = 799
// module chunks = 0